export default __webpack_public_path__ + "static/media/frg--orchard-parklands.c93041b3.png";